<template>
  <div
    v-if="showErrors"
    :class="$style.withMargins"
  >
    <transition
      :enterActiveClass="$style.slideEnterActive"
      :enterClass="$style.slideEnter"
      :leaveActiveClass="$style.slideLeaveActive"
      :leaveToClass="$style.slideLeaveTo"
    >
      <ScimTestErrorsList
        v-if="testConnectionErrorsList.length"
        :class="$style.panelMarginBotton"
        :errorsList="testConnectionErrorsList"
      />
      <ScimTestErrorsList
        v-if="configurationErrorsList.length"
        :class="$style.panelMarginBotton"
        :errorsList="configurationErrorsList"
      />
    </transition>
  </div>
</template>

<script>
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';
import ScimTestError from 'client/applications/scim/ScimTestError';
import ScimTestErrorsList from 'client/applications/scim/ScimTestErrorsList.vue';

export default {
  name: 'GenericScimConnectorErrors',

  components: {
    ScimTestErrorsList,
  },

  mixins: [IdentityManagementMixin],

  props: {
    testConnectionErrorsCategoryFilter: {
      type: String,
      default: undefined,
    },
  },

  computed: {
    showErrors() {
      const areTestErrorsPresent = this.connectionErrorsList.length > 0;
      const areConfigErrorsPresent = this.configurationErrorsList.length > 0;
      return areTestErrorsPresent || areConfigErrorsPresent;
    },

    testConnectionErrorsList() {
      const filter = this.testConnectionErrorsCategoryFilter;
      const filteredTestConnectionErrors = this.testConnectionErrors
        .reduce((finalList, err) => {
          const matchesFilter = filter && (filter === err.category);
          const isUncategorized = !filter && !err.category;
          const shouldAddError = matchesFilter || isUncategorized;

          if (shouldAddError) {
            finalList.push(new ScimTestError(err.errorType, err.message));
          }

          return finalList;
        }, []);

      return filteredTestConnectionErrors;
    },
  },
};
</script>

<style module>
@import 'css/IdentityManagementCommon.css';

.withMargins {
  margin: 2rem 0;
}
</style>
